import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const SubCtx = createContext(null);
export const TIER_ORDER = { free: 0, pro: 1, elite: 2 };

export function SubscriptionProvider({ children }) {
  const { user } = useAuth();
  const [sub, setSub] = useState({ tier: "free", plan_tier: "free", status: "none", period: null, trial: null });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    if (!user) { setLoading(false); return; }
    setLoading(true);
    api.get("/subscription").then((r) => setSub(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const isAdmin = user?.role === "admin";
  const effectiveTier = isAdmin ? "elite" : (sub.tier || "free");
  const trial = sub.trial || null;
  const onTrial = !isAdmin && !!trial?.active;
  const has = (need) => TIER_ORDER[effectiveTier] >= TIER_ORDER[need];

  return (
    <SubCtx.Provider value={{ ...sub, effectiveTier, planTier: sub.plan_tier || "free", trial, onTrial, isAdmin, has, refresh, loading }}>
      {children}
    </SubCtx.Provider>
  );
}

export const useSub = () => useContext(SubCtx);
